export default{
    cadastra:{
        method:'post',
        url:'trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'trabalhador/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'trabalhador/lista'
    },
    editar:{
        method:'get',
        url:'trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'trabalhador/update'
    },
    evento2200:{
        method:'post',
        url:'trabalhador/evento/cadastro/2200'
    },
    eventodelete2200:{
        method:'delete',
        url:'trabalhador/evento/deletar/2200{/id}'
    },
    eventoupdate2200:{
        method:'put',
        url:'trabalhador/evento/update/2200'
    },
    evento2300:{
        method:'post',
        url:'trabalhador/evento/cadastro/2300'
    },
    eventodelete2300:{
        method:'delete',
        url:'trabalhador/evento/deletar/2300{/id}'
    },
    eventoupdate2300:{
        method:'put',
        url:'trabalhador/evento/update/2300'
    },
    eventolista:{
        method:'get',
        url:'trabalhador/evento/2200/lista{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
   
   
    documento:{
        method:'get',
        url:'documentos/trabalhador/lista?id={id}'
    },
    matricula:{
        method:'get',
        url:'trabalhador/matricula'
    },
    perfil:{
        method:'get',
        url:'trabalhador/perfil{/id}'
    },
    
}
